import { Stack } from "src/shared/components"
import RoleForm from "../../component/role-form"
import { RoleFormParam } from "../../roles.type"
import {
  Status,
  useAddOrRemovePermissionsByRoleIdMutation,
  useGetPermissionandandRoleByIdSuspenseQuery,
  useUpdateRoleMutation
} from "src/graphql/quark/quark.type"
import { toast } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import ROUTE_PATHS from "src/routes/route-path"
import { useMemo } from "react"

const UpdateRole = () => {
  const navigate = useNavigate()
  const { roleId } = useParams()
  const [updateRole, { loading: isLoadingUpdateRole }] = useUpdateRoleMutation()
  const [addOrRemovePermissionsByRoleId, { loading: isLoadingAddRemovePermissions }] =
    useAddOrRemovePermissionsByRoleIdMutation()

  const { data: respData } = useGetPermissionandandRoleByIdSuspenseQuery({
    variables: { roleId: roleId as string },
    errorPolicy: "ignore",
    fetchPolicy: "network-only",
    skip: !roleId
  })

  const values = useMemo((): RoleFormParam | undefined => {
    if (!respData?.roles?.id) return undefined
    return {
      id: respData?.roles?.id,
      name: respData?.roles?.name as string,
      status: respData?.roles?.status as Status,
      permissions: respData?.permissions?.map((val) => val?.id) || []
    }
  }, [respData?.permissions, respData?.roles])
  const handleSubmit = async (val: RoleFormParam) => {
    // val
    const respUpdateRole = await updateRole({
      variables: {
        updateRoleId: val?.id as string,
        roleInputDto: {
          name: val.name,
          status: val.status
        }
      }
    })
    if (!respUpdateRole?.data?.updateRole) {
      toast.error("Creation Failed | Something went wrong.")
      return
    }
    const respAddRemoveRolePermission = await addOrRemovePermissionsByRoleId({
      variables: {
        roleId: val?.id as string,
        permissionIds: val.permissions as string[]
      }
    })
    if (respAddRemoveRolePermission.data?.addOrRemovePermissionsByRoleId) {
      toast.success(`Role ${val.name} created successfully.`)
      navigate(ROUTE_PATHS.ROLES.BASE)
      return
    }
  }
  return (
    <Stack p={2}>
      <RoleForm
        roleValues={values}
        isSubmitting={isLoadingUpdateRole || isLoadingAddRemovePermissions}
        onSubmit={handleSubmit}
      />
    </Stack>
  )
}

export default UpdateRole
